
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinauranga() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Aurangabad',
        heading: 'etravo :  Corporate Cab and Bus Services in Aurangabad',
        headingDescription: 'eTravo offers reliable and professional Corporate Cab and Bus Services in Aurangabad, designed to streamline business travel for organizations of all sizes. Whether you need executive cabs for VIP transfers and meetings or corporate buses for staff transportation and events, our fleet delivers punctuality, comfort, and safety. With GPS-enabled vehicles, trained chauffeurs, and a strong focus on service excellence, eTravo ensures a smooth and efficient travel experience. Partner with us in Aurangabad for hassle-free corporate mobility that keeps your operations moving forward.',

        top: 'Top Places to Visit in Aurangabad with etravo',
  "topPlaces": [
    {
      "title": "Ajanta Caves",
      "description": "The Ajanta Caves are a UNESCO World Heritage Site comprising 30 rock-cut Buddhist cave monuments dating from the 2nd century BCE to about 480 CE. Renowned for their exquisite murals and sculptures, these caves are masterpieces of Buddhist religious art, depicting various Jataka tales and events from the life of the Buddha."
    },
    {
      "title": "Ellora Caves",
      "description": "Ellora Caves, another UNESCO World Heritage Site, feature 34 rock-cut temples and monasteries representing Buddhist, Hindu, and Jain traditions. The highlight is the Kailasa Temple (Cave 16), a monolithic structure dedicated to Lord Shiva, showcasing remarkable ancient Indian rock-cut architecture."
    },
    {
      "title": "Bibi Ka Maqbara",
      "description": "Often referred to as the 'Taj of the Deccan,' Bibi Ka Maqbara is a 17th-century mausoleum built by Azam Shah in memory of his mother, Dilras Banu Begum. Its striking resemblance to the Taj Mahal and its serene gardens make it a prominent attraction in Aurangabad."
    },
    {
      "title": "Daulatabad Fort",
      "description": "Originally known as Devagiri Fort, Daulatabad Fort is a 12th-century fortress located about 16 km from Aurangabad. Known for its formidable defense mechanisms, including a moat and a series of gates, the fort offers panoramic views and a glimpse into medieval military architecture."
    },
    {
      "title": "Grishneshwar Temple",
      "description": "Located near the Ellora Caves, Grishneshwar Temple is one of the 12 Jyotirlingas dedicated to Lord Shiva. The temple, built in the 18th century, showcases traditional South Indian temple architecture and holds immense religious significance."
    },
    {
      "title": "Aurangabad Caves",
      "description": "Situated on a hill overlooking the city, the Aurangabad Caves are 12 rock-cut Buddhist shrines dating back to the 6th and 7th centuries. The caves are known for their intricate carvings and offer a tranquil spot with panoramic views of Aurangabad."
    },
    {
      "title": "Soneri Mahal",
      "description": "Soneri Mahal, meaning 'Golden Palace,' is a 17th-century palace located within the campus of Dr. Babasaheb Ambedkar Marathwada University. The palace houses a museum displaying artifacts and paintings, reflecting the region's rich history and culture."
    },
    {
      "title": "Valley of the Sufi Saints (Khuldabad)",
      "description": "Khuldabad, known as the Valley of the Sufi Saints, is a historic town housing the tombs of several Sufi saints and Mughal emperor Aurangzeb. The area is a spiritual hub and offers insights into the region's Islamic heritage."
    },
    {
      "title": "Panchakki",
      "description": "Panchakki, meaning 'water mill,' is a 17th-century structure that harnessed water power to grind grain for pilgrims. The complex includes a mosque, a madrasa, and a garden, reflecting the engineering ingenuity of the era."
    },
    {
      "title": "Siddharth Garden and Zoo",
      "description": "Siddharth Garden is a well-maintained public garden featuring lush lawns, flower beds, and a zoo housing various animal species. It's a popular spot for families and offers a relaxing environment within the city."
    }
  ],
   "services": [
    {
      "name": "Business Travel Cabs & Buses Aurangabad",
      "description": "eTravo offers professional business travel cabs and buses in Aurangabad for companies looking to streamline executive and staff mobility. Whether it’s for outstation client meetings, daily staff commutes, or intercity travel, we provide AC sedans, SUVs, and buses with trained drivers and real-time tracking. Our services are designed to ensure punctuality, comfort, and professionalism for every business journey."
    },
    {
      "name": "Corporate Commute Services Aurangabad",
      "description": "eTravo’s corporate commute services in Aurangabad are perfect for businesses seeking efficient, daily transportation for employees. We provide reliable pick-up and drop services, tailored to shift timings and route preferences. Our fleet includes clean, air-conditioned cabs and buses supported by GPS tracking, route planning, and customer support, ensuring smooth and stress-free commuting."
    },
    {
      "name": "Staff Shuttle Services Aurangabad",
      "description": "Simplify your staff transportation in Aurangabad with eTravo’s dedicated shuttle services. Ideal for factories, offices, IT parks, and BPOs, our shuttles are scheduled based on workforce availability and operational hours. With safety features, route optimization, and flexible vehicle capacity, we ensure on-time transportation that supports productivity and employee satisfaction."
    },
    {
      "name": "Corporate Conference Transport Aurangabad",
      "description": "Planning a corporate conference or seminar in Aurangabad? eTravo offers complete transport solutions to handle all your logistics, from group pick-ups to delegate drop-offs. We manage buses and cabs for attendees, speakers, and VIPs, ensuring timely arrival and a smooth experience. Our service includes route planning, event coordination, and vehicle monitoring for a stress-free conference transport experience."
    },
    {
      "name": "Office Transport Solutions in Aurangabad",
      "description": "From small teams to large organizations, eTravo provides reliable office transport solutions in Aurangabad that align with your company's workforce mobility needs. Our services include employee routing, shift-based planning, and scalable cab and bus allocations. Backed by trained drivers, AC vehicles, and technology-driven tracking, we deliver dependable transport every day."
    },
    {
      "name": "Hire Buses and Cabs for Corporate Events in Aurangabad",
      "description": "eTravo makes it easy to hire buses and cabs for corporate events in Aurangabad, whether you're hosting a product launch, training session, or offsite retreat. We offer a wide fleet of well-maintained vehicles to handle transportation for large and small groups. Our team assists with scheduling, real-time tracking, and on-site coordination to ensure your event runs smoothly."
    },
    {
      "name": "Luxury Cab & Bus Rentals Aurangabad",
      "description": "Travel in comfort and class with eTravo’s luxury cab and bus rentals in Aurangabad. Designed for executive use, leadership offsites, and VIP guest transport, our premium fleet includes high-end sedans, SUVs, and luxury coaches. With plush seating, climate control, and professional chauffeurs, our luxury transport services offer the perfect blend of style and efficiency for your corporate needs."
    }
  ],
  "tableData": [
    ["Business Travel Cabs & Buses Aurangabad", "Corporate Commute Services Aurangabad"],
    ["Staff Shuttle Services Aurangabad", "Corporate Conference Transport Aurangabad"],
    ["Office Transport Solutions in Aurangabad", "Hire Buses and Cabs for Corporate Events in Aurangabad"],
    ["Luxury Cab & Bus Rentals Aurangabad", ""]
  ],







"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Transport for Corporates",
        "WhyChoosedescription": "At eTravo, we understand that punctuality is key in the corporate world. Our cab and bus services in Aurangabad are built around reliability and time efficiency. Whether it’s regular employee transportation, client transfers, or event logistics, we ensure your team is always on schedule without compromising comfort or professionalism."
    },
    {
        "WhyChooseheading": "Diverse Fleet for Every Corporate Need",
        "WhyChoosedescription": "eTravo offers a full range of transport options in Aurangabad, from executive cabs for senior leadership and guests to large, comfortable buses for group travel. Each vehicle is air-conditioned, clean, and equipped with modern amenities to ensure a productive and pleasant journey for all corporate passengers."
    },
    {
        "WhyChooseheading": "Trained and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are professionally trained, background-verified, and skilled in handling corporate transport requirements. With excellent route knowledge of Aurangabad and surrounding areas, they ensure a smooth, safe, and respectful travel experience for your staff, clients, and business partners."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "eTravo believes in complete pricing transparency. We provide upfront, itemized quotes for all our corporate cab and bus services in Aurangabad, with no hidden fees or last-minute additions. This helps businesses manage transport budgets effectively while getting top-notch service."
    },
    {
        "WhyChooseheading": "Safety-Driven Transportation Experience",
        "WhyChoosedescription": "Every eTravo vehicle is equipped with GPS tracking, seat belts, emergency tools, and is maintained under strict safety protocols. We also conduct regular sanitization and vehicle inspections to ensure each ride in and around Aurangabad is not just smooth—but secure and worry-free."
    },
    {
        "WhyChooseheading": "24/7 Operational Support for Business Travel",
        "WhyChoosedescription": "Our team is available round the clock to support your corporate travel requirements in Aurangabad. From early morning airport runs to late-night event returns, eTravo ensures you have consistent access to transport support, booking adjustments, and emergency coordination at any hour."
    },
    {
        "WhyChooseheading": "Quick, Simple, and Centralized Booking System",
        "WhyChoosedescription": "Booking corporate cabs and buses with eTravo is fast and convenient. Use our intuitive online portal or get assistance from our support team to handle one-time trips, recurring schedules, or large group bookings with real-time updates and complete control."
    },
    {
        "WhyChooseheading": "Customized Corporate Travel Solutions",
        "WhyChoosedescription": "eTravo offers tailor-made travel packages designed specifically for businesses in Aurangabad. Whether you need daily commutes, travel for outstation meetings, or transportation for corporate events and offsites, we’ll build a solution around your exact schedule, team size, and travel standards."
    }
]























    }


   

// Corporate Cab and Bus Services in Aurangabad – eTravo

const faqData = [
    [
        {
            question: 'What corporate transport services does eTravo provide in Aurangabad?',
            answer: 'eTravo offers end-to-end corporate transportation in Aurangabad, including employee cab pickups, AC bus services, executive transfers, and transport arrangements for corporate events and meetings.',
        },
        {
            question: 'Can eTravo handle daily employee commute requirements in Aurangabad?',
            answer: 'Yes, we specialize in structured daily commutes for employees with route optimization, shift-based scheduling, and fleet management using cabs and buses to ensure smooth daily operations.',
        },
        {
            question: 'What kind of vehicles are available for corporate clients in Aurangabad?',
            answer: 'Our corporate fleet includes sedans, SUVs, multi-seaters, and air-conditioned buses with different seating capacities — all maintained to high standards of cleanliness, comfort, and safety.',
        },
        {
            question: 'Are safety and tracking features included in your services?',
            answer: 'Yes, all vehicles are GPS-enabled and come with real-time tracking access for the corporate client. Trip history, driver details, and compliance reports are also regularly.',
        },
        {
            question: 'Can we book outstation or intercity corporate travel from Aurangabad?',
            answer: 'Absolutely. eTravo provides corporate cab and bus services for outstation travel, site visits, or intercity meetings with complete itinerary planning and travel coordination.',
        },
        {
            question: 'Do you provide dedicated account support for companies in Aurangabad?',
            answer: 'Yes, every corporate client receives a dedicated account manager to oversee operations, handle changes, generate reports, and provide ongoing customer support.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Ashok Patil',
        designation: 'Operations Manager, SynergyTech Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo for our corporate transport in Aurangabad, and the experience has been consistently professional. Their team is responsive and always punctual.”',
    },
    {
        name: 'Ms. Kavita Desai',
        designation: 'HR Head, NovaCore Enterprises',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has helped us streamline our employee transportation in Aurangabad. Their cabs and buses are clean, well-managed, and their support team is quick to respond.”',
    },
];





















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Aurangabad",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-aurangabad.jpg",
  "description": "Reliable corporate cab and bus services in Aurangabad by eTravo for business travel, staff shuttles, corporate conferences, and office commute. Choose from luxury and affordable AC vehicles with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3995"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-aurangabad"
  }
};





    return (
        <div>
<Helmet>
  <title>Corporate Cab and Bus Services in Aurangabad | Staff Shuttle & Business Travel | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Aurangabad with eTravo for office commute, corporate events, and business travel. Luxury and budget-friendly options with reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/9.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinauranga;